<template>
  <b-container fluid class="overall-bg">
    <b-row>
      <b-col>
        <div class="img-center pt-5 ps-3">
          <div class="logo">
            <img src="../../../../assets/Img/icons/Inventorylogo.svg" />
          </div>
          <div>
            <p class="logo-txt mb-0">Mocero Inventory</p>
            <p class="logo-txt-green">A product of Mocero Health</p>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <div class="overall-bg pb-0">
        <b-container>
          <b-row>
            <b-col>
              <BackBtn path="/login" />
            </b-col>
          </b-row>
        </b-container>
      </div>
      <b-col lg="12" md="12" class="forgotpasswordcard pt-5">
        <div class="details-card">
          <div class="">
            <b-form @submit.prevent="forgotpasssubmit()">
              <b-row class="py-4">
                <b-col>
                  <h2>Forgot password</h2>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="12" md="12" sm="12" cols="12">
                  <div class="field">
                    <TextField placeholder="Enter email id" clearable name="Forgot email" label="Email"
                      v-model="forgotpassword.EmailId" :rules="{ required: true, email: true }" id="Forgotemail"
                      :required-icon="true" @keyup="EmailIdKeyUp()" />
                    <p class="mt-2 float-end" :style="{ color: EmailNotiColour.txtColour }">
                      {{ EmailNotiColour.textContent }}
                    </p>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-4" v-if="FieldVisible.newpassword == true">
                <b-col lg="12" md="12" sm="12" cols="12">
                  <div class="field mb-0 position-relative">
                    <div class="blue-txt pwd-icon" @click="passwordshowhide()">
                      <i v-if="showpass == true" class="pi pi-eye-slash"></i>
                      <i v-else class="pi pi-eye"></i>
                    </div>
                    <TextField :txttype="showtxt" placeholder=" " clearable v-model="forgotpassword.newpassword"
                      name="New password" label="New password" :rules="{ required: true, password: true }"
                      id="New password" :required-icon="true" />
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="FieldVisible.confirmpassword == true">
                <b-col lg="12" md="12" sm="12" cols="12">
                  <div class="field position-relative">
                    <div class="blue-txt pwd-icon" @click="confirmshowhide()">
                      <i v-if="showconfpass == true" class="pi pi-eye-slash"></i>
                      <i v-else class="pi pi-eye"></i>
                    </div>
                    <TextField :txttype="showConfirmtxt" placeholder=" " v-model="forgotpassword.confirmpassword"
                      clearable name="Confirm password" label="Confirm password"
                      :rules="{ required: true, password: true }" id="Confirm password" :required-icon="true" />
                    <p v-if="showError" class="err_msg_style">
                      Password must be same
                    </p>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="d-flex flex-row-reverse">
                  <Footer class="py-2" :goback="$router.back" label="Submit" :loading="loader" />
                </b-col>
              </b-row>
            </b-form>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import BackBtn from "../../../../components/FormComponents/BacktoMaster.vue";
import TextField from "../../../../components/FormComponents/TextInput.vue";
import { Field, useForm } from "vee-validate";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import PasswordService from "../../Service/PasswordService";
import UpdatedSuccessfully from "../../../../components/FormComponents/UpdatedSuccessfully.vue";
import Footer from "../../../../components/FormComponents/Footer.vue";

export default defineComponent({
  components: {
    TextField,
    BackBtn,
    UpdatedSuccessfully,
    Footer,
  },

  setup() {
    let show = ref(true);
    let showpass = ref(true);
    let showconfpass = ref(true);
    let showConfirmtxt = ref("Password");
    let showtxt = ref("Password");
    const showError = ref(false);
    const updatepop = ref(false);
    const router = useRouter();
    let loader = ref(false);
    const { handleSubmit, errors, resetForm, resetField } = useForm();

    function passwordshowhide() {
      if (showpass.value == true) {
        showpass.value = false;
        showtxt.value = "text";
      } else {
        showpass.value = true;
        showtxt.value = "Password";
      }
    }
    function confirmshowhide() {
      debugger;
      if (showconfpass.value == true) {
        showconfpass.value = false;
        showConfirmtxt.value = "text";
      } else {
        showconfpass.value = true;
        showConfirmtxt.value = "Password";
      }
    }

    let forgotpassword = ref({
      EmailId: "",
      newpassword: "",
      confirmpassword: "",
    });

    let FieldVisible = ref({
      newpassword: false,
      confirmpassword: false,
    });

    let EmailNotiColour = ref({
      txtColour: "",
      textContent: "",
    });

    let UserChangePasswordObjVal = ref({
      UserId: 0,
      Password: "",
    });

    const forgotpasssubmit = handleSubmit(async (values) => {
      debugger;
      loader.value = true;
      if (
        forgotpassword.value.newpassword !==
        forgotpassword.value.confirmpassword
      ) {
        loader.value = false;
        showError.value = true;
      } else {
        showError.value = false;
        let msg = "";

        if (UserChangePasswordObjVal.value.UserId == 0) {
          let response = await PasswordService.GetUserMailId(
            forgotpassword.value.EmailId
          );
          console.log(response["result"]);
          msg = response["ErrorInfo"].ErrorCode;

          UserChangePasswordObjVal.value.UserId = response["result"][0].UserId;

          if (response["result"][0].msg == "Exists") {
            loader.value = false;
            EmailNotiColour.value.txtColour = "green";
            EmailNotiColour.value.textContent = "✓ Verified";

            FieldVisible.value.newpassword = true;
            FieldVisible.value.confirmpassword = true;
          } else {
            loader.value = false;
            EmailNotiColour.value.txtColour = "red";
            EmailNotiColour.value.textContent = "Invalid Email Id";
          }
        } else {
          UserChangePasswordObjVal.value.Password =
            forgotpassword.value.confirmpassword;

          let response = await PasswordService.ChangePassword(
            UserChangePasswordObjVal.value
          );
          console.log(response["result"]);

          msg = response["ErrorInfo"].ErrorCode;

          // Login Credential Mail
          const UserResponse = await PasswordService.GetUserById(
            UserChangePasswordObjVal.value.UserId
          );

          if (UserResponse["result"] == "") {
            loader.value = false;
            alert("Somthing went wrong");
            return;
          }
          const DatabyUserId = UserResponse["result"][0];

          let UserObj = ref({
            // AppName: "Inventory",
            AppName: "",
            UserName: "",
            UserCode: "",
            EmailId: "",
            Password: "",
            // AppUrl: "https://inventory.convenientcare.life/",
            AppUrl: "",
            Content:
              "We want to inform you that a password reset has been initiated for your patient app account. If you did not request this change, please disregard this notification.  Account security is our priority. If you initiated the password reset, you can now log in using your updated credentials.",
          });

          UserObj.value.UserName = DatabyUserId.UserName;
          UserObj.value.UserCode = DatabyUserId.Code;
          UserObj.value.EmailId = DatabyUserId.EmailId;
          UserObj.value.Password = DatabyUserId.DecodedPassword;

          const MailResponse = await PasswordService.ForgotPasswordSendMail(
            UserObj.value
          );

          let MailMsg = MailResponse["ErrorInfo"].ErrorCode;
          console.log(MailResponse["result"]);
          //

          if (msg == null && MailMsg == null) {
            loader.value = false;
            updatepop.value = true;
          } else {
            loader.value = false;
            alert("Somthing went wrong");
          }
        }
      }
    });

    function EmailIdKeyUp() {
      debugger;
      EmailNotiColour.value.txtColour = "";
      EmailNotiColour.value.textContent = "";
      forgotpassword.value.newpassword = "";
      forgotpassword.value.confirmpassword = "";
      UserChangePasswordObjVal.value.UserId = 0;
      FieldVisible.value.newpassword = false;
      FieldVisible.value.confirmpassword = false;
    }

    function closetrigger() {
      updatepop.value = false;
      router.push({
        path: "/login",
      });
    }

    return {
      router,
      EmailIdKeyUp,
      updatepop,
      closetrigger,
      FieldVisible,
      forgotpasssubmit,
      forgotpassword,
      showError,
      showConfirmtxt,
      showconfpass,
      showpass,
      passwordshowhide,
      confirmshowhide,
      showtxt,
      show,
      EmailNotiColour,
      loader,
    };
  },
});
</script>

<style lang="scss" scoped>
.logo {
  background-color: #f7f7f8;
  border-radius: 50%;
  margin-right: 10px;
}

.logo img {
  width: 40px;
  margin: 5px;
}

.img-center {
  display: flex;
  align-items: center;
}

.logo-txt {
  font-weight: 500;
  font-size: 18px;
  color: #444444;
}

.logo-txt-green {
  font-size: 12px;
  color: #55c0a2;
}

.forgotpasswordcard {
  display: flex;
  justify-content: center;
}

.forgotpasswordcard .details-card {
  width: 40%;
}
</style>
